declare class Stripe {
  constructor(publicKey: string);
  redirectToCheckout({
      sessionId
  }: {
      sessionId: string;
  }): Promise<{ error: Error }>;
}

export const stripe = new Stripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY ? process.env.REACT_APP_STRIPE_PUBLIC_KEY : '');